const locale = {
	// #region Tickets fields
	DETAILS_TICKETS_FIELD_TITLE: 'Title',
	DETAILS_TICKETS_FIELD_STATUS: 'Ticket Status',
	DETAILS_TICKETS_FIELD_TYPE: 'Ticket Type',
	DETAILS_TICKETS_FIELD_COMPANY: 'Customer Company',
	DETAILS_TICKETS_FIELD_PERSON: 'External Contact',
	DETAILS_TICKETS_FIELD_ASSIGNED_USER: 'Internal assigned User',
	DETAILS_TICKETS_FIELD_ASSIGNED_USER_2: 'External assigned User',
	DETAILS_TICKETS_FIELD_DATE_FROM: 'Start date',
	DETAILS_TICKETS_FIELD_DATE_TO: 'End date',
	DETAILS_TICKETS_FIELD_INTERNALNUMBER: 'Internal number',
	DETAILS_TICKETS_FIELD_TAGS: 'Tags',
	DETAILS_TICKETS_FIELD_WARNING: 'Warning',
	DETAILS_TICKETS_FIELD_BLOCKED: 'Blocked'
	// DETAILS_TICKETS_FIELD_HOURS: 'Expected hours',
	// #endregion
};

export default locale;
